import {FC} from 'react';
import TextField from '@mui/material/TextField';

type TimeInputProps = {
  value: string;
  description: string;
}

const TimeInput: FC<TimeInputProps> = ({value, description}) => {
  return (
    <div className="input-wrapper">
      <TextField
        size="small"
        label={description}
        value={value}
        disabled
      />
    </div>
  );
};

export default TimeInput;
